import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { CopyService } from '../copies/copy.service';

export enum ValidatorsPatterns {
  ADDRESS = 'address',
  PHONE = 'phone',
  PLAIN_TEXT = 'plainText',
  ALPHANUMERIC = 'alphanumeric',
  NUMERIC = 'numeric',
  CEDULA = 'cedula',
  NIT = 'nit',
  EXTRANJERIA = 'cedulaExtranjeria',
  PASAPORTE = 'pasaporte',
  PATTERN_SOC_EXT_SIN_NIT_COL = 'socExtSinNitCol',
  FIDEICOMISO = 'fdc',
  PQR = 'pqrNumber',
  TI = 'ti',
  PD = 'pasaporteDiplomatico'
}

@Injectable({
  providedIn: 'root'
})
export class ValidatorFormFieldService {

  private _validators: any;

  constructor(private readonly _copies: CopyService) { }

  /**
   * Permite obtener los mensajes de las reglas de validación usadas en los fomularios
   */
  get validators() {
    return new Promise(async (resolve) => {
      if (!this._validators) {
        this.validators = await this._copies.getCopy('validationsFormFields');
      }
      resolve(this._validators);
    })
  }

  /**
   * Permite establecer los mensajes de las reglas de validación usadas en los fomularios
   */
  set validators(value: any) {
    this._validators = value;
  }

  /**
   *
   * @param label
   * @param formControl
   * @param errors
   * @returns
   */
  async getMessageError(label: string, formControl: AbstractControl, errors: any)
  {
    let defaultValue = '';
      if (formControl && formControl.invalid) {
        const errorsKeys = errors ? Object.keys(errors) : [];

        if (errorsKeys && Array.isArray(errorsKeys) && errorsKeys.length >= 1) {
          const errorCode = errorsKeys.shift();
          if (errorCode && errors && errors.hasOwnProperty(errorCode)) {
            const inputVars = { ...errors[errorCode] };
            inputVars['field'] = label;
            defaultValue = await this.processMessageError(errorCode, inputVars);
          }
        }
        return defaultValue;
      } else {
        return defaultValue;
      }
  }

  /**
   *
   * @param errorCode
   * @param inputsVars
   * @param pattern
   * @returns
   */
  async processMessageError(errorCode: string, inputsVars: any) {

    let pattern = '';

    if(inputsVars.hasOwnProperty('requiredPattern')){
      pattern = inputsVars.requiredPattern;
    }
    const validators = await this.validators;
    let message = "";
    if (validators) {
      for (const validatorCode of Object.keys(validators)) {
        const validator: {
          message: string,
          pattern?: string
        } = validators[validatorCode];
        if ((validatorCode === errorCode) || (errorCode === 'pattern' && pattern && validator.pattern === pattern)) {
          message = validator.message;
          break;
        }
      }
      if (!message && validators.hasOwnProperty('default') && validators.default.hasOwnProperty('message')) {
        message = validators.default.message;
      }else if(!message){
        message = '{field} no contiene un formato o valor correcto.';
      }
    }
    return this.replaceInputsMessageError(message, inputsVars);
  }

  /**
   * Permite reemplazar las variables comodin con los datos suministrados
   * @param message
   * @param inputsVars
   */
  replaceInputsMessageError(message: string, inputsVars: any) {
    for (const inputName of Object.keys(inputsVars)) {
      const inputValue = inputsVars[inputName];
      message = `${message}`.replace(`{${inputName}}`, inputValue);
    }
    return message;
  }

  /**
   *
   * @param code
   * @returns
   */
  async validatorPattern(code: string) {
    const validators = await this.validators;
    if (validators.hasOwnProperty(code) && validators[code].hasOwnProperty('pattern')) {
      return validators[code].pattern;
    } else {
      return null;
    }
  }

  /**
   *
   * @param min
   * @returns
   */
  minLengthArray(min: number) : any{
    return (c: AbstractControl): {[key: string]: any} | null  => {
        if (c.value.length >= min){
          return null;
        }
        return { 'minLengthArray': {valid: false }};
    }
}
}
